import { Components } from "@mui/material/styles";

export const MuiAlert: Components['MuiAlert'] = {
    styleOverrides: {
        root: {
            backgroundColor: '#FFFFFF',
            color: '#005075',
            borderRadius: 'unset',
            fontFamily: 'Roboto',
            fontWeight: '400',
            fontSize: '16px'
        },
        standardInfo: {
            '& .MuiIconButton-root': {
                color: '#005075'
            },
            border: `1px solid #005075`,
            color: '#005075',
            borderBottom: `3px solid #005075`,
            '& .MuiAlert-icon': {
                fill: '#005075'
            },
            '& svg': {
                fill: '#005075'
            }
        },
        standardSuccess: {
            '& .MuiIconButton-root': {
                color: '#09822A'
            },
            border: `1px solid #09822A`,
            borderBottom: `3px solid #09822A`,
            color: '#09822A',
            '& .MuiAlert-icon': {
                fill: '#09822A'
            }
        },
        standardWarning: {
            '& .MuiIconButton-root': {
                color: '#FDB927'
            },
            border: `1px solid #FDB927`,
            borderBottom: `3px solid #FDB927`,
            color: '#FDB927',
            '& .MuiAlert-icon': {
                fill: '#FDB927'
            }
        },
        standardError: {
            '& .MuiIconButton-root': {
                color: '#D82829'
            },
            border: `1px solid #D82829`,
            borderBottom: `3px solid #D82829`,
            color: '#D82829',
            '& .MuiAlert-icon': {
                fill: '#D82829'
            },
            '& button': {
                fill: '#D82829'
            }
        }
    }
};
